import {
	ADD_USER_ENDPOINT,
	BASE_URL,
	CHECK_USER_ENDPOINT,
	FETCH_PINCODE_DETAILS_ENDPOINT,
	HTTP_OK,
	HTTP_STATUS_SUCCESS,
	RESPONSE_STATUS_CODES,
	SEND_OTP_ENDPOINT,
	STATIC_API_KEYS,
	VERIFY_OTP_ENDPOINT,
} from "../../utils/constants";
import { getBaseUrl } from "../../utils/utils";
import {
	registerUserBegin,
	registerUserFailure,
	registerUserSuccess,
	sendOTPBegin,
	sendOTPFailure,
	sendOTPSuccess,
	verifyOTPBegin,
	verifyOTPSuccess,
	verifyOTPFailure,
	fetchPincodeDetailsBegin,
	fetchPincodeDetailsSuccess,
	fetchPincodeDetailsFailure,
	checkUserBegin,
	checkUserSuccess,
	checkUserFailure,
} from "../register";
import { apiGet, apiPost } from "./api";

export const sendOTP = (payload) => async (dispatch, getState) => {
	await dispatch(sendOTPBegin());

	try {
		const { status, data } = await dispatch(
			apiPost(`${getBaseUrl()}${SEND_OTP_ENDPOINT}`, {
				body: payload,
				headers: {
					"x-api-key": STATIC_API_KEYS.user,
				},
			})
		);
		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(sendOTPSuccess({ data, status }));

				return true;
			} else {
				await dispatch(sendOTPFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(sendOTPFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const verifyOTP = (payload) => async (dispatch, getState) => {
	await dispatch(verifyOTPBegin());

	try {
		const { status, data } = await dispatch(
			apiPost(`${getBaseUrl()}${VERIFY_OTP_ENDPOINT}`, {
				body: payload,
				headers: {
					"x-api-key": STATIC_API_KEYS.user,
				},
			})
		);
		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(verifyOTPSuccess({ data, status }));

				return true;
			} else {
				await dispatch(verifyOTPFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(verifyOTPFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const registerUser = (payload) => async (dispatch, getState) => {
	await dispatch(registerUserBegin());

	try {
		const { status, data } = await dispatch(
			apiPost(`${getBaseUrl()}${ADD_USER_ENDPOINT}`, {
				body: payload,
				headers: {
					"x-api-key": STATIC_API_KEYS.user,
				},
			})
		);

		if (status === HTTP_OK) {
			const response = data || false;

			if (
				response.status === HTTP_STATUS_SUCCESS &&
				response.status_code === RESPONSE_STATUS_CODES.USER_CREATED
			) {
				await dispatch(registerUserSuccess({ data, status }));

				return true;
			} else {
				await dispatch(registerUserFailure({ message: JSON.stringify(status), response }));

				return false;
			}
		} else {
			await dispatch(registerUserFailure(data, status));

			return false;
		}
	} catch (e) {
		await dispatch(registerUserFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const fetchPincodeDetails = (payload) => async (dispatch, getState) => {
	await dispatch(fetchPincodeDetailsBegin());

	try {
		const { status, data } = await dispatch(
			apiGet(`${getBaseUrl()}${FETCH_PINCODE_DETAILS_ENDPOINT}?pincode=${payload.pincode}`, {
				headers: {
					"x-api-key": STATIC_API_KEYS.admin,
				},
			})
		);

		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(fetchPincodeDetailsSuccess({ data: response.data, status }));

				return response.data;
			} else {
				await dispatch(fetchPincodeDetailsFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(fetchPincodeDetailsFailure({ message: JSON.stringify(e) }));

		return false;
	}
};

export const checkUserExist = (payload) => async (dispatch, getState) => {
	await dispatch(checkUserBegin());

	try {
		const { status, data } = await dispatch(
			apiGet(
				`${getBaseUrl()}${CHECK_USER_ENDPOINT}?firstName=${payload.firstName}&lastName=${
					payload.lastName
				}&fathersName=${payload.fathersName}&mobileNumber=${payload.mobileNumber}`,
				{
					headers: {
						"x-api-key": STATIC_API_KEYS.admin,
					},
				}
			)
		);

		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(checkUserSuccess({ data: response.data, status }));

				return response.status_code === RESPONSE_STATUS_CODES.USER_NOT_EXISTS ? false : true;
			} else {
				await dispatch(checkUserFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(checkUserFailure({ message: JSON.stringify(e) }));

		return false;
	}
};
